import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
var baseUri = "WebApi.asmx/api/modulTypeAttributeService";
const store = {};
const mutations = {
    GET_MODULTYPE_ATTRIBUTE_DETAIL(state, posts) {
        state.modulTypeAttributeDetail = posts.data;
    },
    DELETE_MODULTYPEATTRIBUTE_DETAIL() { 
    },
    SAVE_MODULTYPEATTRIBUTE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.modulTypeAttributeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    modulTypeAttributeDetail: {},
    modulTypeAttributeDetailChanged: false
};

const getters = {};

const actions = {
    getModulTypeAttributeDetail({ commit }, data) {
        var formData = new FormData();
        formData.append("matId", data.matId);
        return axios
            .post(baseUri + '/GetModulTypeAttributeDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_MODULTYPE_ATTRIBUTE_DETAIL', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.errorMessage);
                    return {};
                }
            });
    },
    saveModulTypeAttributeDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.modulTypeAttributeDetail));
        axios
            .post(baseUri + '/SaveModulTypeAttributeDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_MODULTYPEATTRIBUTE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }

            });
    },
    deleteModulTypeAttributeDetail({ commit }, { matId }) {
        var formData = new FormData();
        formData.append("matId", matId);
        return axios
            .post(baseUri + '/DeleteModulTypeAttributeDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('DELETE_MODULTYPEATTRIBUTE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}